import Util from "./Util.js";
//
import { gsap } from "./Util.js";

class Resize extends Util {
  constructor() {
    super();
    this.init();
  }

  init() {
    website.winW = window.innerWidth;
    website.winH = window.innerHeight;

    this.set();
    this.tabletHide();
    this.update();
  }

  set() {
    let that = this;

    window.removeEventListener("resize", this.resizeHandler);
    this.common();

    let w = window.innerWidth,
      timer = false;

    this.resizeHandler = function () {
      if (timer !== false) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        // that.tabletHide();

        if (!website.isDesktop) {
          if (w === window.innerWidth) {
            return;
          }
        }

        website.winW = window.innerWidth;
        website.winH = window.innerHeight;

        if (880 > website.winW) {
          if (website.isDesktop) {
            website.isDesktop = false;
            location.reload();
          }
        } else {
          if (!website.isDesktop) {
            website.isDesktop = false;
            location.reload();
          }
        }

        website.isDesktop = window.innerWidth >= 1025 ? true : false;

        that.update();

        w = window.innerWidth;
      }, 400);
    };

    window.addEventListener("resize", this.resizeHandler);
  }

  common() {
    // if (this.website.winW >= 1025) {
    //   let winPer = this.website.winW / 1440;
    //   gsap.set("html", {
    //     style: "font-size:" + 62.5 * winPer + "%",
    //   });
    // } else {
    //   let winPer = this.website.winW / 375;
    //   gsap.set("html", {
    //     style: "font-size:" + 62.5 * winPer + "%",
    //   });
    // }
  }

  tabletHide() {
    // if (website.isTablet || !website.isDesktop) {
    //     const alertElement = document.getElementById('alert');
    //     if (window.innerWidth >= window.innerHeight) {
    //         alertElement.classList.add('show');
    //     } else {
    //         alertElement.classList.remove('show');
    //     }
    // }
  }

  update() {
    this.common();

    // if (!website.isDesktop && !website.isTablet) {
    //     if ($('.sp-h-fit').length) {
    //         gsap.set('.sp-h-fit', {
    //             height: website.winH
    //         });
    //     }
    // }
  }
}

export default Resize;
